import type { ReactNode } from "react";
import styled from "styled-components";

import { color } from "../../theme/color";

/** A list next to what's picked from it on a tablet. On a phone, only one of them at a time: the detail, if there is one. */
export function SplitView(props: { listLabel: string; list: ReactNode; detail?: ReactNode }) {
    const showingDetail = !!props.detail;

    return (
        <Layout>
            <ListPane aria-label={props.listLabel} $hiddenOnPhone={showingDetail}>
                {props.list}
            </ListPane>
            <DetailPane $hiddenOnPhone={!showingDetail}>{props.detail}</DetailPane>
        </Layout>
    );
}

const Layout = styled.div`
    flex: 1;
    min-width: 0;
    display: flex;
`;

const ListPane = styled.section<{ $hiddenOnPhone: boolean }>`
    width: 100%;
    display: ${({ $hiddenOnPhone }) => ($hiddenOnPhone ? "none" : "flex")};
    flex-direction: column;
    min-height: 0;

    @media (min-width: 700px) {
        display: flex;
        width: 360px;
        flex-shrink: 0;
        border-right: 1px solid ${color.border};
    }
`;

const DetailPane = styled.section<{ $hiddenOnPhone: boolean }>`
    flex: 1;
    min-width: 0;
    min-height: 0;
    overflow: auto;
    display: ${({ $hiddenOnPhone }) => ($hiddenOnPhone ? "none" : "flex")};
    flex-direction: column;

    @media (min-width: 700px) {
        display: flex;
    }
`;
